import React, { useState, useEffect } from "react";
import styles from "./Home.module.sass";
import TooltipGlodal from "../../components/TooltipGlodal";
import Calendar from "../../components/Calendar";
import Anniversary from "../../components/Anniversary";
import Overview from "./Overview";
import ModalAttendance from "../../components/ModalAttendance";
import { useAuth } from "../../contexts/AuthContext";
import { getStudentById } from "../../services/student.service";
import { getAttendancesForCurrentUser } from "../../services/attendances.service";
import ArticleCarousel from "./ArticleCarousel";

const Home = () => {
    const { currentUser } = useAuth();
    const [studentData, setStudentData] = useState(null);
    const [attendances, setAttendances] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingAttendances, setLoadingAttendances] = useState(true);
    const [selectedAttendance, setSelectedAttendance] = useState(null);
    const [showAttendanceModal, setShowAttendanceModal] = useState(false);

    useEffect(() => {
        const fetchStudentData = async () => {
            try {
                if (currentUser?.student_id) {
                    const student = await getStudentById(currentUser.student_id);
                    setStudentData(student);
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des données étudiant:', error);
            } finally {
                setLoading(false);
            }
        };
        
        const fetchAttendances = async () => {
            try {
                if (currentUser?.student_id) {
                    const result = await getAttendancesForCurrentUser({
                        perPage: 100, // Récupérer plus d'attendances pour le calendrier
                        sort: 'created' // Tri croissant pour avoir les plus anciennes en premier
                    });
                    setAttendances(result.items || []);
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des attendances:', error);
                setAttendances([]);
            } finally {
                setLoadingAttendances(false);
            }
        };
        
        if (currentUser) {
            fetchStudentData();
            fetchAttendances();
        } else {
            setLoading(false);
            setLoadingAttendances(false);
        }
    }, [currentUser]);
    
    const isUserBirthday = () => {
        if (!studentData?.birth_date) return false;
        
        const today = new Date();
        const birthDate = new Date(studentData.birth_date);
        
        return today.getDate() === birthDate.getDate() && 
               today.getMonth() === birthDate.getMonth();
    };

    // Fonction pour gérer le clic sur un meeting
    const handleMeetingClick = (meeting) => {
        if (meeting.attendance) {
            setSelectedAttendance(meeting.attendance);
            setShowAttendanceModal(true);
        }
    };

    // Fonction pour fermer la modal
    const handleCloseModal = () => {
        setShowAttendanceModal(false);
        setSelectedAttendance(null);
    };
    
    if (loading || loadingAttendances) {
        return (
            <div className={styles.loading}>
                Chargement...
            </div>
        );
    }
    
    return (
        <>
            <div className={styles.row}>
                <div className={styles.col}>
                    <Overview 
                        className={styles.card} 
                        currentUser={currentUser}
                    />
                   <ArticleCarousel currentUser={currentUser}/>
                </div>
                <div className={styles.col}>
                    <Calendar 
                        className={styles.card} 
                        views="6" 
                        attendances={attendances}
                        onMeetingClick={handleMeetingClick}
                    />
                    {isUserBirthday() && (
                        <Anniversary
                            title="Joyeux anniversaire ! 🎉"
                            classTitle="title-red"
                            firstName={studentData?.first_name || currentUser?.first_name}
                            lastName={studentData?.last_name || currentUser?.last_name}
                        />
                    )}
                </div>
            </div>
            <TooltipGlodal />
            
            {/* Modal pour afficher les détails d'une attendance */}
            <ModalAttendance
                visible={showAttendanceModal}
                onClose={handleCloseModal}
                attendance={selectedAttendance}
            />
        </>
    );
};

export default Home;
